import { z } from 'zod';

/**
 * The package of a driver hired by the day (`scheduleType` CAR_DRIVER, #6876), as the schedule
 * wrote it. `franchise` is free text: the legacy app writes its label ("Até 8h - 100km"), the
 * Intelligence the key ("8H"). The extras are TOTALS (unit × quantity); `null` = not hired.
 */
export const MobilityCarDriverSchema = z.object({
  vehicle: z.string().nullable(),
  franchise: z.string().nullable(),
  days: z.number().int().nullable(),
  dailyValue: z.number().nullable(),
  bilingual: z.number().nullable(),
  overnight: z.number().nullable(),
  overnightNights: z.number().int().nullable(),
});
export type MobilityCarDriver = z.infer<typeof MobilityCarDriverSchema>;
